import { createFileRoute } from '@tanstack/react-router';

// The columns alone, with no modal open
export const Route = createFileRoute('/_authenticated/placement/')({});
